<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkVideoChat from "./BookmarkVideoChat.svelte";
  import Card from "../../../Core/Card.svelte";
  import CallChatSidebar from "../ChatApp/CallChatSidebar.svelte";
  import ChatCenterSide from "./ChatCenterSide.svelte";
  import VideoChatRightSide from "./VideoChatRightSide.svelte";
</script>

<BookmarkVideoChat />
<Container fluid>
  <Row>
    <CallChatSidebar />
    <Col class="call-chat-body">
      <Card cardBodyprops="p-0">
        <div slot="contentbody">
          <Row class="chat-box">
            <ChatCenterSide />
            <VideoChatRightSide />
          </Row>
        </div>
      </Card>
    </Col>
  </Row>
</Container>
